import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { A365Named } from '../base/a365Named';
import { ModelConstants } from '../model-constants';
import { IViolation } from '../base/annotation';
import { ActionConstants } from '../../constants/action-constants';
import { getGeneralNamePatterns } from '../../shared/utils/validation.util';

@Metamodel.model({
    name: ModelConstants.sparkConfiguration,
    display: [shellStringResources.ApacheSparkConfiguration, shellStringResources.ApacheSparkConfigurations],
    reusable: true,
    referable: true,
    validator: SparkConfiguration.validate,
    constraints: {
        name: {
            required: true,
            patterns: getGeneralNamePatterns(shellStringResources.ApacheSparkConfiguration),
            uniqueModelName: true
        }
    },
    accessPublishConstraint: {
        writeResource: {
            action: ActionConstants.sparkConfigurationsWrite
        },
        deleteResource: {
            action: ActionConstants.sparkConfigurationsDelete
        }
    }
})

export class SparkConfiguration extends A365Named {
    @Metamodel.attribute({
        display: shellStringResources.Configurations
    })
    public configs: { [key: string]: string };

    @Metamodel.attribute({
    })
    public rawTags: { [key: string]: string };

    @Metamodel.attribute({
    })
    public annotations?: string[];

    @Metamodel.attribute({
        display: shellStringResources.Notes
    })
    public notes?: string;

    @Metamodel.attribute({
    })
    public date?: string;

    @Metamodel.attribute({
    })
    public createdBy?: string;

    public violations: string[];

    @Metamodel.attribute({
    })
    public configMergeRule: { [key: string]: string };

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static validate(owner: any): IViolation[] | undefined {
        const named = (owner && owner.named) as SparkConfiguration;

        if (named && named.violations) {
            return named.violations.map((violation) => ({
                context: owner,
                message: () => violation
            }));
        }

        return undefined;
    }
}
